export const getFieldValues = (data, field) => {
	const result = {};
	data.forEach(m => {
		const value = m[field] || "-";
		if(!result[value]) {
			result[value] = 1;
		}
	});

	return Object.keys(result).sort((a, b) => a.localeCompare(b));
};

export const createChartDatasets = (data, categories, categoriesField, labels, labelField) => {
	const datasets = [];

	categories.forEach(cat => {
		const values = {};
		const filteredData = data.filter(d => d[categoriesField] === cat);

		filteredData.forEach(d => {
			const label = d[labelField];
			if(!values[label]) {
				values[label] = 1;
			}
			else {
				values[label] ++;
			}
		});
		datasets.push({ label: cat, values });
	});
	return datasets;
};
